import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { arrayOf, number, func, string } from 'prop-types'

export const DEFAULT_PER_PAGE_OPTIONS = [5, 40, 80]

function PerPage({
  perPage,
  onPerPageChange: handlePerPageChange,
  options = DEFAULT_PER_PAGE_OPTIONS,
  label = 'Per page',
}) {
  return (
    <div className="shared-pagination__per-page">
      <span className="shared-pagination__per-page-label">
        {label}
      </span>
      <div className="shared-pagination__per-page-options">
        {options.map((value) => (
          <Button
            key={value}
            type="secondary"
            size="small"
            customClass="shared-pagination__per-page-btn"
            onClick={() => handlePerPageChange(value)}
            isActive={value === perPage}
          >
            {value}
          </Button>
        ))}
      </div>
    </div>
  )
}

PerPage.propTypes = {
  perPage: number.isRequired,
  onPerPageChange: func.isRequired,
  options: arrayOf(number),
  label: string,
}

export default PerPage
